import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';

const ViewPocs = ({ match, getCorpPocList = null, corpClientPoc = null }) => {
  const headers = [
    'POC Name',
    'POC Designation',
    'Mobile Number',
    'Email Address',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [reqData, setReqData] = useState();
  const [leadId, setLeadId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/brand-activation/corporate-client/add-poc/${match.params.siteId}/${match.params.id}`}
          className="btn btn-primary d-md-inline-block"
        >
          Add POC
        </Link>
      </Fragment>
    );
  };
  useEffect(() => {
    setLeadId(match.params.id);
  }, []);
  useEffect(() => {
    if (getCorpPocList !== null && leadId)
      (async () => {
        setIsLoading(true);
        await getCorpPocList(leadId);
        setIsLoading(false);
      })();
  }, [getCorpPocList, leadId]);

  useEffect(() => {
    const tableData = [
      'id',
      'poc_name',
      'poc_designation',
      'poc_contact_no',
      'poc_email',
    ];
    if (corpClientPoc && corpClientPoc) {
      const data = corpClientPoc.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Actions: {
              name: 'Edit Details',
              link: `${baseUrl}/brand-activation/corporate-client/edit-poc/${match.params.siteId}/${match.params.id}/${element.id}`,
              from: 'pocList',
            },
          }
        )
      );
      data && setListData(data);
      //   setPageCount(Math.ceil(corpClientPoc.total / corpClientPoc.per_page));
    }
  }, [corpClientPoc]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getCorpPocList(leadId, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.viewPOCs}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/corporate-list/${match.params.siteId}`}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={corpClientPoc?.from}

        // onPageChange={onPageChange}
      />
    </Layout>
  );
};

export default ViewPocs;
